import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetServerConfigurationResponse extends ApiGenericResponse {
    configurationEntries: ConfigurationEntry[] = [];

    constructor(response: AxiosResponse) {
        super(response);
        this.configurationEntries = [];
        if (response.data && response.data.Payload && response.data.Payload.length > 0) {
            response.data.Payload.forEach((e) => {
                var m = new ConfigurationEntry();
                m.parse(e);
                this.configurationEntries.push(m);
            });
        }
    }

    getPasswordPolicy(): ConfigurationEntry[] {
        return this.configurationEntries.filter((e) => e.section == "PASSWORD_POLICY");
    }
}

export class ConfigurationEntry {
    section: string;
    key: string;
    value: string;

    public parse(obj: any) {
        this.section = obj.Section;
        this.key = obj.Key;
        this.value = obj.Value;
    }
}
